import { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import { PatientProfileTabs } from "./PatientProfileTabs";
import { PatientPersonalInfo } from "patients-experience-client";
import { PatientProfileHeader } from "./PatientProfileHeader";
import Error503 from "../error-503";
import Error404 from "../error-404";
import { createPatientApi } from "../../api-helpers/PatientApiHelper";
import { ProfilePageLoader } from "../../components/ProfilePageLoader";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

export interface PatientTabProps {
  patient?: PatientPersonalInfo;
}

export const PatientProfile = () => {

  const { patientId } = useParams<{ patientId: string }>();

  const [patientProfile, setPatientProfile] = useState<PatientPersonalInfo>();
  const [loading, setloading] = useState(true);
  const [error, setError] = useState<{statusCode: number, message: string}>();
  const patientApi = createPatientApi();
  const patientProfileReloadKey = useSelector((state: RootState) => state.patientProfileReloadKey.patientProfileReloadKey);

  useEffect(() => {
    getPatientProfile();
  }, [patientId, patientProfileReloadKey]);

  const getPatientProfile = async () => {
    setloading(true);
    setError({
      ...error,
      statusCode: 0,
      message: ''
    });
    try {
      const response =
        await patientApi.patientsControllerGetPatientPersonalInfo(patientId!);
      setPatientProfile(response.data);
    } catch (error: any) {
      setError({
        ...error,
        statusCode: error.response.status,
        message: error.response.data.message.message
      });
      console.error("Error fetching Patients:", error);
    } finally {
      setloading(false);
    }
  };

  return (
    <main className="main patient-profile-main">
      {error?.statusCode === 404 && <Error404 statusCode={error?.statusCode} errMessage={error?.message} />}
      {error?.statusCode !== 0 && error?.statusCode !== 404 && <Error503 />}
      {error?.statusCode === 0 && loading && <ProfilePageLoader />}
      {error?.statusCode === 0 && !loading && (
        <>
          <PatientProfileHeader patientProfile={patientProfile!} />
          <PatientProfileTabs />
          <Outlet context={patientProfile} />
        </>
      )}
    </main>
  );
};
